import { ClickAwayListener } from '@mui/material'
import PopupSection from 'components/popup/PopupSection'
import { ReactNode, useState } from 'react'
import { COLORS } from 'utils/colors'

import * as Styled from '../styled'
import GroupcalTooltip from 'components/tooltips/GroupcalTooltip'
import { t } from 'i18next'
import MemberCanSection from '../groupInfo/MembersCanSection'
import { GroupDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { useAddGroup } from './AddGroupProvider'

interface MemberCanPopupInterface {
  children: ReactNode
  group: Model<GroupDoc>
  open?: boolean
  setOpen: (b: boolean) => void
}

function MemberCanPopupContent(props: MemberCanPopupInterface) {
  const addGroupProvider = useAddGroup()

  return (
    <MemberCanSection
      setError={() => {}}
      setLoading={() => {}}
      error=""
      group={props.group}
      metaDataState={addGroupProvider.metaDataState}
      allCanAddItemsState={addGroupProvider.allCanAddItemsState}
      addParticipantsState={addGroupProvider.addParticipantsState}
      eventOwnershipState={addGroupProvider.eventOwnershipState}
      eventOwnershipCheck={(event) => {
        addGroupProvider.setEventOwnershipState(
          event.target.checked ? '1' : '0'
        )

        if (
          addGroupProvider.allCanAddItemsState === '0' &&
          event.target.checked
        ) {
          addGroupProvider.setAllCanAddItemsState('1')
        }
      }}
      addParticipantsCheck={(event) => {
        addGroupProvider.setAddParticipantsState(
          event.target.checked ? '1' : '0'
        )
      }}
      allCanAddItemsCheck={(event) => {
        addGroupProvider.setAllCanAddItemsState(
          event.target.checked ? '1' : '0'
        )

        if (
          addGroupProvider.eventOwnershipState === '1' &&
          !event.target.checked
        ) {
          addGroupProvider.setEventOwnershipState('0')
        }
      }}
      groupMetaDataCheck={(event) => {
        addGroupProvider.setMetaDataState(event.target.checked ? '1' : '0')
      }}
    />
  )
}

export default function MemberCanPopup(props: MemberCanPopupInterface) {
  return (
    <Styled.MembersCanPopup
      open={props.open}
      setOpen={props.setOpen}
      placement="left"
      content={<MemberCanPopupContent {...props} />}
    >
      {props.children}
    </Styled.MembersCanPopup>
  )
}
